<template>
  <div class="parking-sale-page">
    <ParkingSaleForm />
    <ContactFooter />
  </div>
</template>

<script>
import ParkingSaleForm from '@/components/ParkingSaleForm.vue';
import ContactFooter from '@/components/ContactFooter.vue';

export default {
  name: 'ParkingSalePage',
  components: {
    ParkingSaleForm,
    ContactFooter,
  },
};
</script>

<style scoped>
.parking-sale-page {
  margin-top: 0px;
  background-color: var(--background-gray);
  width: 100%;
}
</style>
